import React, { useEffect, useState, useRef, useCallback, useMemo } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";
import { Link, useLocation } from "react-router-dom";
import "../../../investor/investor.css";
import { AgGridReact } from "ag-grid-react";
import { SBDatePicker } from "../../../UiComponents/SBDatePicker";
import { SBGrid } from "../../../UiComponents/SBAAGgrid";
import { SBAMultiSelectCheck, SBAMultiColumnComboBox, SBADropDown} from "../../../UiComponents/SBADropDown";
import moment from "moment";
import { LoadingScreen } from "../../../UiComponents/LoadingComponent";
import { getActivitiesDetails, getCategory } from "../../../actions/investmentAction";
import {getInvestorActivitiesAction } from "../../../actions/investorAccounts";
import { getCustomSettings, getcategory, getActivityEntity, DownloadDocument,getTaxEntitiesByContact, getUserPageAccess } from "../../../../config/apiConfig";
import { sbaAxios } from "../../..//utils/sbaAxios";
import { DateRangePicker } from "rsuite";
import { getTaxEntitiesByContactAction } from "../../../actions/contactsAction";
import { getMultipleDocs } from "../../../actions/assetDocumentsActions";
import { getAssetNoteDetails } from "../../../actions/assetNotestabAction";
import { SBDateRangePicker } from "../../../UiComponents/SBDateRangePicker";
import { UrlPath } from "../../../../config/routeConfig";

export const Documents = (props) => {
  const locationData = useLocation();
  const dispatch = useDispatch();
  const params = useParams();
    const documentListRef = useRef();
    const Gstate = useSelector((state) => state) || {};
    const isEditable = Gstate.authorizationData.isEditable;
    const activities = Gstate?.investorAccounts.InvestorActivitiesDetails || [];
    const [TaxEntitiesByContact,setTaxEntitiesByContact]= useState();
    const activitesGridLoading = Gstate?.investorAccounts.isInvestorActivitiesDetailsLoading;
    const [Category,setCategory] = useState();
    const storeDocuments = Gstate.mutipleDocuments?.mutipleDocuments || [];
    const [ActivitySubTypeIds, setActivitySubTypeIds] = useState(Category);
    const oneMonthAgo = new Date();
    oneMonthAgo.setMonth(oneMonthAgo.getMonth() - 1);
    const [categoryselected, setCategorySelected] = React.useState([]);
    const [StartDate, setStartDate] = useState(oneMonthAgo);
    const [EndDate, setEndDate] = useState(new Date());
    const [dateRange, setDateRange] = useState([new Date(oneMonthAgo), new Date()]);

    const [selectedEntityids, SetselectedEntityids] = useState(TaxEntitiesByContact);
    const [Entityselected, setEntitySelected] = React.useState([]);

    const [includecontact, SetIncludeContact] = useState(true);
    const [Subject, setSubject] = useState("");
    const [Relatedcontact, SetIRelatedContact] = useState(false);
    const [activityTypeId,setactivityTypeId]=useState(null);
    const [clientReportingEdit,setClientReportingEdit]=useState(false);
    const getAccessForEdit = async () => {
        try {
            const response = await sbaAxios({ url:  `${getUserPageAccess}?keyName=ClientReportingEditAccess` });
            setClientReportingEdit(response);            
        } catch (error) {
        }
    };
    const navigate = useNavigate();
  useEffect(() => {
      document.title = `Investor Details`;
      getCategoryList();
      dispatch(getTaxEntitiesByContactAction(params.ContactId));
      fetchGridData();
      getAccessForEdit();
       
             
  }, []);
    // useEffect(() => {
    //     setCategorySelected({ value: Category, allSelected: true });
    //     setEntitySelected({ value: TaxEntitiesByContact, allSelected: true });
    //     SetselectedEntityids(TaxEntitiesByContact);
    //     setActivitySubTypeIds(Category);
    // }, [Category]);
    const getCategoryList = async () => {
        try {

            const response = await sbaAxios({
                url: `${getcategory}${2}`,
                method: 'get',
            });
            const data = response;
            setCategory(data);
            const Ids=data?.map((acctype)=>acctype.ActivitySubTypeId);
            setActivitySubTypeIds(data);
            setCategorySelected({ value: data, allSelected: true });
            getTaxEntities(Ids);
        } catch (error) {
            console.error("Error fetching entities from API:", error);
        }
    };

    const getTaxEntities = async (activitysubtypeId) => {
        try {

            const response = await sbaAxios({
                url: `${getTaxEntitiesByContact}${params.ContactId}`,
                method: 'get',
            });
            const data = response;
            setTaxEntitiesByContact(data);
            SetselectedEntityids(data);
            setEntitySelected({ value: data, allSelected: true });
            const AccountIds=data?.map((acctype)=>acctype.TaxEntityId);
            dispatch(getInvestorActivitiesAction(params.ContactId,AccountIds,2,moment(StartDate).format("MM/DD/YYYY"),moment(EndDate).format("MM/DD/YYYY"),activitysubtypeId,Subject ));
          
        } catch (error) {
            console.error("Error fetching entities from API:", error);
        }
    };
    const gridValueFormatter = (params) => {
        return <input type='checkbox' checked={params.value} />;
    };
    const assetNameKeyCreator = (params) => {
        var data = params.data;
        return data.AssetName;
    };
    const dateKeyCreator = (params) => {
        var data = params.data;
        return moment(data.ActivityDate).format("MM/DD/YYYY");
    };
    const activityTypeNameKeyCreator = (params) => {
        var data = params.data;
        return data.ActivityType;
    };
    const subjectNameKeyCreator = (params) => {
        var data = params.data;
        return data.ActivityName;
    };
    const createdNameKeyCreator = (params) => {
        var data = params.data;
        return data.CreatedByName;
    };
    
    const checkBoxFormatter = (params) => {
        return <input type='checkbox' checked={params.value === true} disabled />;
    };
    const valuformaterapply = (params) => {
        return moment(params.value).format("MM/DD/YYYY");
    }

    const loadOnEnter = (event) => {
        if (event.key === 'Enter') {
            enterbtnClick()
        }
    };
    const entityTypeRenderer = (params) => {
        if (params.value === 0)
            return 'Contact';
        else if (params.value === 1)
            return 'Account';
        else
            return '';
    }

   

    const ActionsRenderer = (event,clientReportingEdit) => {
        
        if(event.data.ActivitySubType=='Client Reporting')
        {
            return (<div className="actions-cell">
            <i className="fas fa-edit" style={{ color:  clientReportingEdit === false ? "#808080" : "#47A547", margin: "0 8px", cursor: "pointer" }}></i>        
        </div>)
        }
        else
        return (
            <div className="actions-cell">
                <i 
                    className="fas fa-edit" 
                    style={{ color:  isEditable === false ? "#808080" : "#47A547", margin: "0 8px", cursor: "pointer" }}
                    onClick={()=> {
                        console.log('event click: ', event);
                        if(!isEditable){
                            return;
                        }
                        navigate(`${UrlPath.DocumentInvestorEdit}${event.data.ActivityId}`, {
                            state: {
                                from: locationData.pathname,
                                activeTab:'Documents'
                            },
                        })
                    }}
                ></i>        
            </div>
        );
    };
    // Category Multiselect Onchange...
    const CategoryDDChange = (e) => { 
        const currentSelectAll = categoryselected.value.some((i) => i.ActivitySubType.trim() === "All");
        const nextSelectAll = e.value.some((i) => i.ActivitySubType.trim() === "All");
        let value = e.value;
        const currentCount = categoryselected.value.length;
        const nextCount = value.length;

        if (
            nextCount > currentCount &&
            !currentSelectAll &&
            !nextSelectAll &&
            Category.length - 1 === nextCount
        ) {
            value = Category;
        } else if (
            nextCount < currentCount &&
            currentCount === Category.length &&
            currentSelectAll &&
            nextSelectAll
        ) {
            value = value.filter((v) => v.ActivitySubType.trim() !== "All");
        } else if (!currentSelectAll && nextSelectAll) {
            value = Category;
        } else if (currentSelectAll && !nextSelectAll) {
            value = [];
        }
        setCategorySelected({ value });
        setActivitySubTypeIds(value);
    };
    const columnDefs = [
        
        {
            field: "AssetName",
            headerName: "Asset",
            // filter: "agSetColumnFilter",
            valueFormatter: gridValueFormatter,
            filterParams: {
                keyCreator: assetNameKeyCreator,
                convertValuesToStrings: true,
            },
            tooltipField: 'AssetName'
        },
        {
            field: "Portfolios",
            headerName: "Portfolios",
            filter: "agSetColumnFilter",
            hide: true,
            valueFormatter: gridValueFormatter,
            tooltipField: 'Portfolios'
        },
        {
            field: "Substrategies",
            headerName: "Sub Strategies",
            //  filter: "agSetColumnFilter",
            hide: true,
            valueFormatter: gridValueFormatter,
            tooltipField: 'Substrategies'
        },
        {
            field: "Managers",
            headerName: "Managers",
            filter: "agSetColumnFilter",
            hide: true,
            valueFormatter: gridValueFormatter,
            tooltipField: 'Managers'
        },
        {
            field: "Contacts",
            headerName: "Contacts",
            // filter: "agSetColumnFilter",
            hide: true,
            valueFormatter: gridValueFormatter,
            tooltipField: 'Contacts'
        },
        {
            field: "Contributors",
            headerName: "Contributors",
            // filter: "agSetColumnFilter",
            hide: true,
            valueFormatter: gridValueFormatter,
            tooltipField: 'Contributors'
        },
        {
            field: "ActivityDate",
            headerName: "Document Date",
            maxWidth: 130,
            //  filter: "agSetColumnFilter",
            valueFormatter: (params) => {
                return moment(params.value).format("MM/DD/YYYY");
            },
            filterParams: {
                keyCreator: dateKeyCreator,
                convertValuesToStrings: true,
            },
            tooltipField: 'Document Date'
        },
        {
            field: "ActivityType",
            headerName: "Document",
            maxWidth: 150,
            //  filter: "agSetColumnFilter",
            valueFormatter: gridValueFormatter,
            filterParams: {
                keyCreator: activityTypeNameKeyCreator,
                convertValuesToStrings: true,
            },
            tooltipField: 'Document'
        },
        {
            field: "ActivitySubType",
            headerName: "Activity SubType",
            maxWidth: 130,
            //  filter: "agSetColumnFilter",
            hide: true,
            valueFormatter: gridValueFormatter,
            tooltipField: 'Activity SubType'
        },
        {
            field: "ActivityName",
            headerName: "Subject",
            // filter: "agSetColumnFilter",
            valueFormatter: gridValueFormatter,
            filterParams: {
                keyCreator: subjectNameKeyCreator,
                convertValuesToStrings: true,
            },
            tooltipField: 'ActivityName'
        },
        {
            field: "IsQuarterlyLetter",
            headerName: "Is Partner Letter",
            maxWidth: 130,
            // filter: "agSetColumnFilter",
            hide: true,
            valueFormatter: gridValueFormatter,
            filterParams: {
                filterDefault: false,
            },
            tooltipField: 'IsQuarterlyLetter'
        },
        {
            field: "IsMarketCommentary",
            headerName: "Is Manager Letter",
            maxWidth: 130,
            // filter: "agSetColumnFilter",
            hide: true,
            valueFormatter: gridValueFormatter,
            filterParams: {
                filterDefault: false,
            },
            tooltipField: 'IsMarketCommentary'
        },
        {
            field: "CreatedByName",
            headerName: "Created by",
            maxWidth: 130,
            // filter: "agSetColumnFilter",
            valueFormatter: gridValueFormatter,
            filterParams: {
                keyCreator: createdNameKeyCreator,
                convertValuesToStrings: true,
            },
            tooltipField: 'CreatedByName'
        },
        {
            field: "CreatedDate",
            headerName: "Created Date",
            maxWidth: 130,
            // filter: "agSetColumnFilter",
            hide: true,
            valueFormatter: (params) => {
                return moment(params.value).format("MM/DD/YYYY");
            },
            tooltipField: 'CreatedDate'
        },
        {
            field: "Action",
            headerName: "Action",
            // cellRenderer:()=>{ActionsRenderer} ,
            filter: false,
            maxWidth: 130,
        },
    ];

    const getCustomSetting = async () => {
        try {
            const clientReportingEdit = await sbaAxios({ url:  `${getUserPageAccess}?keyName=ClientReportingEditAccess` });
            const response = await sbaAxios({ url: `${getCustomSettings}1013` });
            if (response) {
                const apiColDef = JSON.parse(response.CustomSettingsValue);
                const filterOptions = response.CustomFilterValue.trim() !== "" ? JSON.parse(response.CustomFilterValue) : null;
                const formattedDef = apiColDef?.map(item => ({
                    ...item,
                    "field": item.colId,
                    cellRenderer: item.colId === "Action" ? (e)=>ActionsRenderer(e,clientReportingEdit) : item.colId === "IsMarketCommentary" ? checkBoxFormatter : item.colId === "IsQuarterlyLetter" ? checkBoxFormatter : item.colId === "ActivityDate" ? valuformaterapply : item.colId === "CreatedDate" ? valuformaterapply : item.colId === "EntityTypeId" ? entityTypeRenderer : item.colId === "IsProcessed"?"agCheckboxCellRenderer":null,
                    "headerName": item.colId === "ActivityDate" ? "Document Date" : item.colId === "ActivitySubType" ? "Document Type" : item.colId === "ActivityName" ? "Document Name" : item.colId === "DocumentStatusName" ? "Status" : null,
                }));
                return { columns: formattedDef, filters: filterOptions };
            }
        } catch (error) {
            console.log(error);
            throw error; 
        }
    };

    const fetchGridData = async () => {
        try {
            const customSettings = await getCustomSetting();
            setColDef(customSettings.columns);
            setAppliedFilter(customSettings.filters);
        } catch (error) {
            console.error("Error fetching custom settings:", error);
        }
    };
    const handleDateChange = (e) => {
        if (e) {
            const newStartDate = e.value.start !== null ? e.value.start : dateRange[0];
            const newEndDate = e.value.end !== null ? e.value.end : dateRange[1];
            setDateRange([newStartDate, newEndDate])
            setStartDate(newStartDate);
            setEndDate(newEndDate);
        }
    };
    const subjectChange = (event) => {
        setSubject(event.target.value);
    };
    const customRanges = [
        {
            label: 'Last 30 Days',
            value: [new Date(new Date().getTime() - 30 * 24 * 60 * 60 * 1000),
            new Date(),],
        },

        {
            label: 'Last 90 Days',
            value: [
                new Date(new Date().getTime() - 90 * 24 * 60 * 60 * 1000),
                new Date(),
            ],
        },
        {
            label: 'YTD',
            value: [
                new Date(new Date().getFullYear(), 0, 1),
                new Date(),
            ],
        },

    ];

    const isRowSelectable = useMemo(() => {
        return (params) => {
            return !!params.data && params.data.NumOfAttachements > 0;
        };
    }, []);
    const [colDef, setColDef] = useState([])
    const [appliedFilter, setAppliedFilter] = useState({})

    const enterbtnClick = () => {
      
        if (StartDate === null && EndDate === null) {
            setStartDate(new Date());
            setEndDate(new Date());
        }
        const CategoryId = ActivitySubTypeIds?.map(
            (ActivitySubTypes) => ActivitySubTypes.ActivitySubTypeId
        );
       const  Entityids=selectedEntityids?.map((accid)=>accid.TaxEntityId);
        dispatch(
            getInvestorActivitiesAction(
                params.ContactId,
                Entityids.join(","),
                2,
                StartDate.toISOString(),
                EndDate.toISOString(),
                CategoryId.join(","),
                Subject
             
            )
        );
       
       // fetchGridData();

    };
    const AccountEntitesChanged = (e) => {
        const value = e.value;
        setEntitySelected({ value });
        SetselectedEntityids(value);
        // const currentSelectAll = Entityselected.value.some((i) => i.TaxEntityName.trim() === "All");
        // const nextSelectAll = e.value.some((i) => i.TaxEntityName.trim() === "All");
        // const currentCount = Entityselected.value.length;
        // const nextCount = value.length;

        // if (
        //     nextCount > currentCount &&
        //     !currentSelectAll &&
        //     !nextSelectAll &&
        //     TaxEntitiesByContact.length - 1 === nextCount
        // ) {
        //     value = TaxEntitiesByContact;
        // } else if (
        //     nextCount < currentCount &&
        //     currentCount === TaxEntitiesByContact.length &&
        //     currentSelectAll &&
        //     nextSelectAll
        // ) {
        //     value = value.filter((v) => v.TaxEntityName.trim() !== "All");
        // } else if (!currentSelectAll && nextSelectAll) {
        //     value = TaxEntitiesByContact;
        // } else if (currentSelectAll && !nextSelectAll) {
        //     value = [];
        // }
       
    }

    const ClearbtnClick = () => {
        setSubject([]);
        setActivitySubTypeIds([]);
        SetselectedEntityids([]);
        setEndDate(new Date());
        var startDate = new Date();
        startDate.setMonth(startDate.getMonth() - 1);
        setStartDate(startDate);
      
         
    };

    // Document Grid in ContacDetails Function to Download Document on Double Click
    const handleRowDoubleClicked = (row) => {
        handleLinkClick(row)
        try {
            const documentId = storeDocuments[0].DocumentId;
            const documentName = storeDocuments[0].DocumentName;
            const urlBuild = DownloadDocument + btoa(documentId.toString());
            sbaAxios({ url: urlBuild }).then((response) => {
                window.open(urlBuild);
            });
        } catch (error) {
            console.error("Error opening document:", error);
        }
    };



 const handleLinkClick = (row) => {
        const ActivityId = row.data.ActivityId;
        dispatch(getMultipleDocs(ActivityId));
        dispatch(getAssetNoteDetails(ActivityId));
    };

  return (
    <>            
              <div id="content">
             
                  <div className="bg-white mb-2 p-3 m-3 border rounded">
                      <form action="#">
                          <div className="row">
                              <div className="col-md-3">
                             
                                  <label
                                      for="select fund"
                                      className="mb-1 ms-2 fw-semibold fs-12"
                                  >
                                      Document Type
                                    </label>
                                  <div>
                                      <SBAMultiSelectCheck
                                          className="w-75"
                                          data={Category}
                                          value={ActivitySubTypeIds}
                                          dataItemKey="ActivitySubTypeId"
                                          textField="ActivitySubType"
                                   
                                          onChange={CategoryDDChange}
                                          tags={
                                              ActivitySubTypeIds?.length > 0
                                                  ? [{ text: `${ActivitySubTypeIds.length} items selected`, data: [...ActivitySubTypeIds] }]
                                                  : []
                                          }
                                          
                                      />
                                  </div>
                             
                              </div>

                               <div className="col-md-3">
                              <label
                                  for="select fund"
                                  className="mb-1 ms-2 fw-semibold fs-12 d-block"
                              >
                                  Accounts
                                    </label>


                              <SBAMultiSelectCheck
                                  className="w-75"
                                  data={TaxEntitiesByContact}
                                  value={selectedEntityids}
                                  dataItemKey="TaxEntityId"
                                  textField="TaxEntityName"
                                  onChange={AccountEntitesChanged}
                                  tags={
                                      selectedEntityids?.length > 0
                                          ? [{ text: `${selectedEntityids.length} items selected`, data: [...selectedEntityids] }]
                                          : []
                                  }

                              />


                              

                          </div>
                               <div className="col-md-3">
                              <label
                                  for="select fund"
                                  className="mb-1 ms-2 fw-semibold fs-12"
                              >
                                  Date Range
                              </label>
                              <SBDateRangePicker
                                  value={{ start: dateRange[0], end: dateRange[1] }}
                                  onChange={(e) => { handleDateChange(e) }}

                              />
                              {/*<DateRangePicker*/}
                              {/*    className="SbaDateRage text-dark"*/}
                              {/*    placeholder="Select Date Range"*/}
                              {/*    value={[*/}
                              {/*        StartDate ? moment(StartDate).toDate() : new Date(),*/}
                              {/*        EndDate ? moment(EndDate).toDate() : new Date(),*/}
                              {/*    ]}*/}
                              {/*    format="MM/dd/yyyy"*/}
                              {/*    onChange={handleDateChange}*/}
                              {/*    block*/}
                              {/*    character=" - "*/}
                              {/*    ranges={customRanges}*/}
                              {/*/>*/}
                          </div>
                          <div className="col-md-3">
                              <label
                                  for="select fund"
                                  className="mb-1 ms-2 fs-12 fw-semibold"
                              >
                                  Document Name
                                    </label>
                              <input
                                  className="w-75 input-default form-control"
                                  type="text"
                                  placeholder="Type here"
                                  onChange={subjectChange}
                                  value={Subject ? Subject : ''}
                                  onKeyUp={loadOnEnter}
                              />
                          </div>

                      </div>
                      <div className="row" style={{ marginTop: "10px" }}>
                              
                              <div className="col-md-3">

                                  <label>  </label>
                                  <label style={{ display: 'flex', alignItems: 'center' }}>
                                      <input
                                          className="me-1"
                                          type="checkbox"
                                      defaultChecked={includecontact}
                                          onChange={(e) => { SetIncludeContact(value => !value) }}
                                      />
                                      <span> Include Contact </span>
                                  </label>
                          </div>

                          <div className="col-md-3">

                              <label>  </label>
                              <label style={{ display: 'flex', alignItems: 'center' }}>
                                  <input
                                      className="me-1"
                                      type="checkbox"
                                      defaultChecked={Relatedcontact}
                                      onChange={(e) => { SetIRelatedContact(value => !value) }}
                                      disabled
                                  />
                                  <span> Related Contact </span>
                              </label>
                          </div>

                              
                              {/* <div className="col-md-3">
                                  <label
                                      for="select fund"
                                      className="mb-1 ms-2 fs-12 fw-semibold"
                                  >
                                      Description
                                    </label>
                                  <input
                                      className="w-75 input-default form-control"
                                      type="text"
                                      placeholder="Type here"
                                      onChange={subjectChange}
                                      value={Subject ? Subject : ''}
                                      onKeyUp={loadOnEnter}
                                  />
                              </div> */}

                          </div>

                               <div className="mt-3">
                              <button
                                  type="button"
                                  className="enter-btn"
                                  onClick={enterbtnClick}
                              >
                                  Enter
                                </button>
                              <button type="button" className="cancel-btn ms-2" onClick={ClearbtnClick}>
                                  Clear All
                                </button>
                          </div>
                         
                        
                      
                      </form>
                  </div>
                  <div>
             
                  <div className="px-3">
                  {activitesGridLoading ? (
                      <LoadingScreen />
                  ) : (
                      <>
                          <SBGrid ref={documentListRef} column={colDef} row={activities} pageSize={15} rowSelection="single" filters={appliedFilter} componentID={1013} gridStyle={{ width: '100%', height: '700px' }} isRowSelectable={isRowSelectable} onRowDoubleClicked={handleRowDoubleClicked}></SBGrid>
                      </>
                  )}

              </div>
          </div>
             
              </div>
      </>
   );
};
